export enum DashboardCardNameEnum {
  RIDE_PAGE_MANUAL_CHANGES_OVERALL = "RIDE_PAGE_MANUAL_CHANGES_OVERALL",
  RIDE_PAGE_MANUAL_CHANGES_PER_USER = "RIDE_PAGE_MANUAL_CHANGES_PER_USER",
  STATUS_NEW_BOOKINGS = "STATUS_NEW_BOOKINGS",
  OVERALL_COST = "OVERALL_COST",
  VEHICLE_TYPE_RIDES_COST = "VEHICLE_TYPE_RIDES_COST",
  RIDES_SUPPLIERS = "RIDES_SUPPLIERS",
  PASSENGERS_WITHOUT_SITE = "PASSENGERS_WITHOUT_SITE",
  OPEN_FEEDBACKS = "OPEN_FEEDBACKS",
  PRICE_RATES_ZERO = "PRICE_RATES_ZERO",
  NONE = "NONE",
}
